"use client"

import React from "react"
// swiper
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"

// import required modules
import { Autoplay, FreeMode, Pagination } from "swiper/modules"


const DATA = [

    {
        icon: "/images/f-1.png",
        heading: "Bulk Tweet Wizard",
        para_1: "Save countless hours by batch-creating tweets for product launches, promotional campaigns, or daily brand engagement.", className: "card_3"
    },
    {
        icon: "/images/f-2.png",
        heading: " Chinu Vision for Media",
        para_1: "Leverage GAN-based image generation to produce visuals that enhance your tweets, or transform them into short videos to captivate your audience.",
        className: "card_2"
    },

    {
        icon: "/images/f-3.png",
        heading: "Chinu Scheduler",
        para_1: "Pinpoint the best posting times using AI-driven insights on follower activity, geographical breakdowns, &  competitor analysis.",
        className: "card_3"
    },
    {
        icon: "/images/f-3.png",
        heading: "Chinu Engage",
        para_1: "Get fresh content ideas around the biggest news in your field, ensuring you’re never out of the conversation loop.",
        className: "card_3"
    },
    {
        icon: "/images/f-4.png",
        heading: "Industry-Tuned Suggestions",
        para_1: "Get fresh content ideas around the biggest news in your field, ensuring you’re never out of the conversation loop.",
        className: "card_3"
    },

]

const COREFEATURES = () => {


    return (
        <div className="md:-mt-10 mt-52 p-[5vw]">
            <div className="md:mb-20 mb-14 space-y-4 w-full text-center">
                <h1 className="md:text-7xl text-4xl font-bold animate__fadeInLeft animate__animated wow">CORE <br />FEATURES</h1>

            </div>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}
                pagination={{
                    clickable: true,
                }}
                breakpoints={{
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                }}
                modules={[FreeMode, Pagination, Autoplay]}
                className="mySwiper !pb-10"
            >
                {DATA.map((item, index) => (
                    <SwiperSlide key={index} className="h-full">
                        <div className="h-full">
                            <div className={`${item.className} p-9 rounded-2xl text-center space-y-3`}>
                                <img src={item.icon} alt="" className="md:w-[4vw] w-[12vw]  mx-auto animate__headShake wow animate__animated animate__infinite custom-duration " />
                                <h2 className="font-medium text-lg animate__fadeInUp wow animate__animated">{item.heading}</h2>
                                <p className="text-gray-400 font-light animate__fadeInUp wow animate__animated">{item.para_1}</p>
                                <p className="text-gray-400 font-light animate__fadeInUp wow animate__animated">{item.para_2}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    )
}

export default COREFEATURES
